export const PATHS = {
  home: "/",
  frontpage: "/home",
  about: "/about",
  services: "/services",
  portfolio: "/portfolio",
  industries: "/industries",
  joinUs: "/joinus",
  contactUs: "/contact-us",
  privacyPolicy: "/privacy-policy",
  portfolioInfo: "/project-info",
  projectInfoWithSlug: "/project-info/:slug",
  portfolioWithSlug: "/portfolio/:slug",
  serviceInfo: "/service-info",
  serviceInfoWithSlug: "/service-info/:slug",
  servicesWithSlug: "/services/:slug",
  industryInfo: "/industry-info",
  industriesWithSlug: "/industries/:slug",
  notFoundPage: "*",
  noDataFoundPage: "/no-data",
};

// Utility function to generate SEO-friendly slugs
export const generateSlug = (title: string): string => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters except hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
};

export const kontentVariables = {
  menu:"menu",
  homePage: "home_page",
  aboutusPage: "about_page",
  portfolioPage: "portfolio_page",
  portfolioInfoContentType: "portfolio_info",
  servicesPage: "services_page",
  serviceCategoriesContentType: "service_categories",  
  serviceByCategoryInfoContentType: "service_content_info",
  serviceCategoryField: "service_category",
  serviceTaxonomies: "service_categories",
  industriesPage: "industries_page",
  industryByCategoryInfoContentType: "industry_content_info",
  industryCategoryField: "industry_category",
  industryTaxonomies: "industry_categories",
  successStoriesPage: "success_stories_section",
  whatMakesusContentType: "what_makes_us",
  ourcorevaluesContentType: "our_core_values",
  joinUsTribeContentType: "join_our_tribe",
  joinusPage: "join_us_page",
  jobRoleContentType: "openings_type",
  jobOpeningsContentType: "openings",
  contactUsPage: "contact_us_page",
  headerPage: "header",
  footerPage: "footer",
  privacyPolicyPage: "privacy_policy",
  servicesContentType: "service_info",  //service_info content type is not so important
};
